// this should match DealListingType enum in deals/constants
export const LISTING_TYPE = {
  INFO: 'info',
  SELECT: 'select',
  ORIGINAL: 'original',
  PLUS_EXCLUSIVE: 'plus_exclusive',
  MARKETPLACE: 'marketplace',
  FREEBIE: 'freebie',
};

// make sure to update imgDetails() of ListingTypeLogo.vue if this arr changes
export const LISTING_TYPES_WITH_LOGO = [
  LISTING_TYPE.SELECT,
  LISTING_TYPE.ORIGINAL,
  LISTING_TYPE.PLUS_EXCLUSIVE,
];

export default {
  LISTING_TYPE,
  LISTING_TYPES_WITH_LOGO,
};
